import PropTypes from "prop-types";
import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

const IntegrationHeader = ({ integration, children }) => {
  switch (integration) {
    default:
      return (
        <div styleName="container">
          <div styleName="label">{integration}</div>
          <div>{children}</div>
        </div>
      );
  }
};

IntegrationHeader.propTypes = {
  integration: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired
};

export default CSSModules(IntegrationHeader, css);
